import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ThemeCustomization from 'themes';
import Routes from 'routes';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import { LicenseInfo } from '@mui/x-license-pro';
import config from 'config';
import TenantGuard from 'middleware/TenantGuard';
import { FeatureProvider } from 'contexts/FeatureContext';
import { initServices } from 'services';

const { muiKey } = config;
LicenseInfo.setLicenseKey(muiKey);

await initServices();

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const domain = searchParams.get('domain')
      ? decodeURIComponent(searchParams.get('domain'))
      : null;

    if (domain) {
      localStorage.setItem('sharedDomainUuid', domain);

      const params = new URLSearchParams(location.search);
      params.delete('domain');

      navigate({
        pathname: location.pathname,
        search: params.toString(),
      }, { replace: true });
    }
  }, []);

  return (
    <ThemeCustomization>
      <RTLLayout>
        <TenantGuard>
          <FeatureProvider>
            <ScrollTop>
              <>
                <Routes />
                <Snackbar />
              </>
            </ScrollTop>
          </FeatureProvider>
        </TenantGuard>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
